// NUM=値 LEN=桁数 
const zeroPadding = (NUM, LEN = 2) => { 
	return (Array(LEN).join('0') + NUM).slice(-LEN); 
}
export default zeroPadding